/**
 * Sets the `.dark` class before first paint.
 *
 * The dark variant is a class rather than a media query because tweakcn writes its dark palette
 * to `.dark` and cannot target `@media (prefers-color-scheme: dark)`. Behaviour for a visitor is
 * unchanged: the system preference still decides, unless they chose otherwise with the toggle.
 *
 * Inline and blocking on purpose. Any later and the page paints light, then flips.
 */
export const THEME_STORAGE_KEY = 'theme'

const SCRIPT = `
(function () {
  try {
    var stored = localStorage.getItem('${THEME_STORAGE_KEY}');
    var dark = stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.classList.toggle('dark', dark);
  } catch (e) {
    /* private mode, blocked storage — fall back to light rather than throwing before paint */
  }
})();
`.trim()

export function ThemeScript() {
    return <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />
}

/**
 * The tweakcn live-preview bridge — DEV ONLY.
 *
 * Lets tweakcn.com/editor/theme (Custom → localhost) push theme changes into the running dev
 * server, so you restyle against the real site. Without this script the editor reports "Script
 * not found". `NODE_ENV` is "development" under `next dev` and never in a `next build`, so it
 * cannot reach a deployment — which matters, because it is a third-party script with permission
 * to restyle the page.
 */
export function TweakcnLivePreview() {
    if (process.env.NODE_ENV !== 'development') { return null }
    // A plain tag, not next/script: it has to run before first paint, and it only exists in dev.
    // eslint-disable-next-line @next/next/no-sync-scripts
    return <script src="https://tweakcn.com/live-preview.min.js" />
}
